// Eight stable hue slots. Contrast is checked against both publications' surfaces
// in presentation.test.mjs; line patterns and the data table also encode identity.
export const LIGHT = ["#2669ad", "#b85120", "#197b5b", "#956d00", "#ab4772", "#49692e", "#7355b5", "#ba4044"];
export const DARK = ["#75ace6", "#f19b6c", "#59b799", "#d9b654", "#e495b6", "#a2ba75", "#b1a0ed", "#ec9291"];
export const SLOTS = 8;

// Use the original series index, never its position after filtering the legend.
export const lineDash = (index) => ["none", "8 4", "2 4", "10 4 2 4", "14 5", "6 3 2 3", "2 3 2 7", "12 3 2 3 2 3"][index % SLOTS];

//	CSS value for a series colour: brand-overridable token resolved on the figure (`--_s<n>`)
export function seriesVar(slot) {
	return `var(--_s${Math.max(1, Math.min(SLOTS, slot | 0))})`;
}

//	a lone series takes the brand accent instead of slot 1
export const ACCENT_VAR = "var(--_accent)";
